import {
  BLOCK_DATE_DEACTIVATE,
  BLOCK_DATE_DEACTIVATE_SUCCESS,
  BLOCK_DATE_DEACTIVATE_ERROR,
  BLOCK_DATE_DEACTIVATE_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const DeactivateBlockDate = (state = initialState, action) => {
  switch (action.type) {
    case BLOCK_DATE_DEACTIVATE:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case BLOCK_DATE_DEACTIVATE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case BLOCK_DATE_DEACTIVATE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case BLOCK_DATE_DEACTIVATE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default DeactivateBlockDate;
